export default __webpack_public_path__ + "static/media/logo.e25f45f7.svg";